<app-spinner [show]="loading" [center]="true"></app-spinner>

<div class="container-fluid p-0" [ngClass]="!error && !loading ? 'd-block' : 'd-none'">
  <div class="row row-cols-auto lh-md">

    <div class="col-12 col-xl-auto">
      <div class="row mb-1">
        <div class="col-12">
          <a class="fw-bolder d-inline-block" href="https://e2.eazeetrak.com/dealers;dealerId={{claimDto!.vendor.vendorId}}/dealer-info?c=contact" target="_blank">
            {{claimDto!.vendor.friendlyName}}<i class="ms-1" data-feather="external-link"></i>
          </a>
        </div>
      </div>
      <div class="row row-cols-2 row-cols-md-3 row-cols-xl-auto">
        <div class="col-12 col-sm-12 col-md-12 col-xl-auto mt-auto mb-2 pe-4">
          {{claimDto!.vendor.address}}<br>
          {{claimDto!.vendor.city}}, {{claimDto!.vendor.provinceState}}
        </div>
        <ng-container *ngIf="dealerStats">
          <div class="col mt-auto mb-2">
            <div class="h3 text-body mb-0">${{dealerStats.activeSales ?? 0 | number: '1.0-0'}}</div>
            <label class="mt-n1">Active Sales</label>
          </div>
          <div class="col mt-auto mb-2">
            <div class="h3 text-body mb-0">${{dealerStats.expiredSales ?? 0 | number: '1.0-0'}}</div>
            <label class="mt-n1">Expired Sales</label>
          </div>
          <div class="col mt-auto mb-2">
            <div class="h3 text-body mb-0">${{dealerStats.prev6MonthsSales ?? 0 | number: '1.0-0'}}</div>
            <label class="mt-n1">Prev 6 Month Sales</label>
          </div>
          <div class="col mt-auto mb-2">
            <div class="h3 text-body mb-0">{{dealerStats.ultimateLossRatio ?? 0 | percent: '1.1-1'}}</div>
            <label class="mt-n1">Ultimate Loss Ratio</label>
          </div>
          <div class="col mt-auto mb-2">
            <div class="h3 text-body mb-0">{{dealerStats.activeLossRatio ?? 0 | percent: '1.1-1'}}</div>
            <label class="mt-n1">Active Loss Ratio</label>
          </div>
          <div class="col mt-auto mb-2 pe-4">
            <div class="h3 text-body mb-0">{{dealerStats.expiredLossRatio ?? 0 | percent: '1.1-1'}}</div>
            <label class="mt-n1">Expired Loss Ratio</label>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="col-12 d-xxl-none border-1 border-bottom border-gray-500 opacity-50 mb-2"></div>
    <div class="col-auto d-none d-xxl-block border-end border-1 border-gray-500 opacity-75 mb-2 p-0"></div>

    <div class="col-12 col-xl-auto">
      <div class="row mb-1">
        <div class="col-12">
          <a class="fw-bolder d-inline-block" href="https://e2.eazeetrak.com/repair-centre/{{claimDto!.repairCentre.repairCentreId}}" target="_blank">
            {{claimDto!.repairCentre.name}}<i class="ms-1" data-feather="external-link"></i>
          </a>
          /
          <a href="mailto:{{claimDto!.submittedBy.email}}">{{claimDto!.submittedBy.firstName}} {{claimDto!.submittedBy.lastName}}</a>
        </div>
      </div>
      <div class="row row-cols-2 row-cols-md-3 row-cols-xl-auto">
        <div class="col mt-auto mb-2 pe-4">
          {{claimDto!.repairCentre.address}}<br>
          {{claimDto!.repairCentre.city}}, {{claimDto!.repairCentre.province}}
        </div>
        <div class="col mt-auto mb-2">
          <div class="h3 text-body text-nowrap mb-0">{{claimDto!.repairCentre.status ?? ''}}</div>
          <label class="mt-n1">Status</label>
        </div>
      </div>
    </div>
    
  </div>
</div>

<p class="text-center my-3" [ngClass]="error ? 'd-block' : 'd-none'">An error occurred while loading dealer and repair center statistics.</p>
